import { LATEST_NEWS_LIMIT } from '@hbac/contract';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { publicPaths } from '../../routes/paths';
import { usePublicPosts } from '../../services/public-queries';
import { PostCard } from '../components/PostCard';
import { latestCardClass } from './latest-news';

/**
 * The newest articles, one full row at each width (two on a phone and a
 * tablet, three from lg; `latest-news.ts`), and "Xem thêm" to the whole list.
 * The button needs no data, so it stands from the first frame; it is always
 * there, since /news is more than these cards (every article, by category).
 */
export function LatestNews() {
  const { data, isPending } = usePublicPosts({ limit: LATEST_NEWS_LIMIT });
  const posts = data?.posts ?? [];

  // An empty news section on a brand-new site looks broken. Hide it entirely
  // until there is something to show.
  if (!isPending && posts.length === 0) return null;

  return (
    <section id="news" className="mx-auto w-full max-w-[1328px] scroll-mt-20 px-4 py-16 md:px-6 md:py-24">
      <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-brand-700 dark:text-brand-400">Tin tức</p>
      <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl lg:text-[42px] lg:leading-[1.15] dark:text-white">
        Mới nhất từ HBAC
      </h2>

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {isPending
          ? // The size of a card without an excerpt, under the same rule of which ones show.
            [...Array(LATEST_NEWS_LIMIT).keys()].map((i) => (
              <div key={i} className={`h-80 animate-pulse rounded-2xl bg-slate-100 dark:bg-navy-800 ${latestCardClass(i)}`} />
            ))
          : posts.map((p, i) => (
              <div key={p.slug} className={latestCardClass(i)}>
                <PostCard post={p} />
              </div>
            ))}
      </div>

      <div className="mt-10 flex justify-center">
        <Link
          to={publicPaths.news}
          className="inline-flex min-h-11 items-center gap-2 rounded-xl border border-slate-200 bg-white px-6 text-sm font-bold text-brand-700 hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 dark:border-navy-700 dark:bg-navy-800 dark:text-brand-300 dark:hover:bg-navy-700 dark:focus-visible:ring-brand-400"
        >
          Xem thêm <ArrowRight size={16} aria-hidden />
        </Link>
      </div>
    </section>
  );
}

